import { useServerStatus } from "@/context/ServerStatusContext";

export function LiveCount({ joinUrl }) {
  const s = useServerStatus();
  const online = s.online === true;
  const dot = s.loading ? "bg-eden-muted" : online ? "bg-emerald-500 animate-pulseDot" : s.online === false ? "bg-red-500" : "bg-amber-500";
  const text = s.loading ? "…" : online ? `${s.players} online` : s.online === false ? "Offline" : "Sem estado";
  const label = s.loading ? "A verificar estado do servidor" : online ? `Servidor online, ${s.players} de ${s.max_players} jogadores` : s.online === false ? "Servidor offline" : "Estado do servidor indisponível";
  return (
    <a
      href={joinUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      title={label}
      className="inline-flex h-8 items-center gap-2 rounded-full border border-eden-border bg-eden-surface px-3 font-mono text-[11px] uppercase tracking-wider text-eden-secondary transition-colors hover:border-eden-secondary hover:text-eden-text"
      data-testid="nav-live-count"
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} aria-hidden="true" />
      <span data-testid="nav-live-count-text">{text}</span>
    </a>
  );
}
